import { map } from 'lodash'

export enum FeatureFlagEnum {
  APP_HEADER_LOGO = 'APP_HEADER_LOGO',
  CALIFORNIA_MEAL_BREAKS = 'CALIFORNIA_MEAL_BREAKS',
  CLAIMED_AND_UNCLAIMED_WORKING_SETS = 'CLAIMED_AND_UNCLAIMED_WORKING_SETS',
  CONTACT_AND_CHANNEL_BROWSERS = 'CONTACT_AND_CHANNEL_BROWSERS',
  CONTACT_EMAILS = 'CONTACT_EMAILS',
  CONTACT_ORGS = 'CONTACT_ORGS',
  DEV_AUTOMATION_COMMANDS = 'DEV_AUTOMATION_COMMANDS',
  DOWNLOAD_AS_TIFF = 'DOWNLOAD_AS_TIFF',
  E_MANIFEST_CAPTURE_TOOL = 'E_MANIFEST_CAPTURE_TOOL',
  ELD_DEVICE_MANAGEMENT = 'ELD_DEVICE_MANAGEMENT',
  ELECTRONIC_SIGNATURE_REQUEST = 'ELECTRONIC_SIGNATURE_REQUEST',
  FEATURE_UPDATES = 'FEATURE_UPDATES',
  INDIVIDUAL_ORG_NOTIFY_PREDICATES = 'INDIVIDUAL_ORG_NOTIFY_PREDICATES',
  LINK_PREVIEW = 'LINK_PREVIEW',
  LOCATION_FOCUSED = 'LOCATION_FOCUSED',
  MENTIONS = 'MENTIONS',
  MENTIONS_REL = 'MENTIONS_REL',
  MULTI_PHONES_ON_IDENTITIES = 'MULTI_PHONES_ON_IDENTITIES',
  OUT_OF_OFFICE_RESPONDER = 'OUT_OF_OFFICE_RESPONDER',
  POSTHOG = 'POSTHOG',
  PUSH_TO_TMS = 'PUSH_TO_TMS',
  RBI_DEMO = 'RBI_DEMO',
  SETTINGS_ADMIN_TABS = 'SETTINGS_ADMIN_TABS',
  SHIPMENT_TOOL = 'SHIPMENT_TOOL',
  VFLOW_ACCOUNT_FILTER = 'VFLOW_ACCOUNT_FILTER',
}

export const FEATURE_FLAGS = map(FeatureFlagEnum, (value) => value)
